import { Navigate, Route, Routes } from 'react-router-dom';

import Layout from '@/Pages/Layout';
import Scan from '@/Pages/Scan';
import Menu from '@/Pages/Menu';
import Cart from '@/Pages/Cart';
import Track from '@/Pages/Track';
import Bill from '@/Pages/Bill';
import More from '@/Pages/More';
import Offers from '@/Pages/Offers';
import Visit from '@/Pages/Visit';
import Feedback from '@/Pages/Feedback';
import ServiceRequests from '@/Pages/ServiceRequests';
import WifiPage from '@/Pages/WifiPage';
import NotFoundPage from '@/Pages/NotFoundPage';
import { useAppSelector } from '@/Redux/store';

/**
 * No login, no app download. The QR token opens a scoped guest session;
 * every other route redirects back to /scan until one exists.
 */
export default function AppRoutes() {
  const session = useAppSelector((s) => s.guest.session);

  return (
    <Routes>
      <Route path="/scan" element={<Scan />} />

      <Route element={session ? <Layout /> : <Navigate to="/scan" replace />}>
        <Route index element={<Navigate to="/menu" replace />} />
        <Route path="menu" element={<Menu />} />
        <Route path="cart" element={<Cart />} />
        <Route path="track" element={<Track />} />
        <Route path="bill" element={<Bill />} />
        <Route path="more" element={<More />} />
        <Route path="offers" element={<Offers />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="visit" element={<Visit />} />
        <Route path="service" element={<ServiceRequests />} />
        <Route path="wifi" element={<WifiPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
